import { Fragment } from 'react'

export enum OnboardingIntegrationType {
  PRODUCT_MANAGEMENT = 'PRODUCT_MANAGEMENT',
  GTM = 'GTM',
  WINLOSS = 'WINLOSS',
  VOICE_OF_CUSTOMER = 'VOICE_OF_CUSTOMER',
}

export enum OnboardingIntegrationTitle {
  PRODUCT_MANAGEMENT = 'AI Product Discovery & Sales Capture',
  GTM = 'AI Campaigns, Assets & Enablement',
  WINLOSS = 'AI Competitive Intelligence & Battlecards',
  VOICE_OF_CUSTOMER = 'AI Voice-of-Customer Analysis',
}

export const OnboardingIntegrationContent = {
  [OnboardingIntegrationType.PRODUCT_MANAGEMENT]: (
    <>
      <p>
        Ignition&apos;s AI continuously <strong>identifies product opportunities</strong> mentioned in customer feedback
        (call transcripts, support tickets, CRM data), then maps ideas to revenue.
      </p>
      <br />
      <p>
        When those ideas are marked “done”, we also <strong>automatically notify Sales</strong> of upsell opportunities
        to capture.
      </p>
    </>
  ),
  [OnboardingIntegrationType.GTM]: (
    <>
      <p>
        Ignition&apos;s AI helps instantly <strong>create launch campaigns</strong> based on your goals, then use your
        messaging, brand guidelines, and voice-of-customer data to <strong>generate marketing assets</strong> tailored
        to your plans & personas.
      </p>
      <br />
      <p>
        Assets are automatically categorized in your master asset library, to easily{' '}
        <strong>brief & enable customer-facing teams.</strong>
      </p>
    </>
  ),
  [OnboardingIntegrationType.WINLOSS]: (
    <>
      <p>
        Ignition&apos;s AI <strong>continuously monitors competitors</strong> via instant battlecards with news,
        reviews, SEO data, and more.
      </p>
      <br />
      <p>
        Integrating your CRM and voice-of-customer data allows you to instantly{' '}
        <strong>analyze Win/Loss insights</strong> and feed them into your intel, as well as{' '}
        <strong>publish battlecards to Sales</strong> within your CRM.
      </p>
    </>
  ),
  [OnboardingIntegrationType.VOICE_OF_CUSTOMER]: (
    <>
      <p>
        Ignition&apos;s AI helps <strong>aggregate and organize customer feedback</strong> from all your calls and
        support tickets, by importing, tagging, and marrying it to CRM account data. Then, you can extract segmented
        takeaways and use your insights to power other Ignition features like planning and asset-creation.
      </p>
      <br />
      <p>
        Then, you can <strong>extract segmented takeaways</strong> and use your insights to power other Ignition
        features like planning and asset-creation.
      </p>
    </>
  ),
}

export const getCalendarInviteDetails = (url: string) =>
  `<p><strong>Integrate with Ignition:</strong><br><a href="${url}">${url}</a><br><ul>Connect CRM, Support, and Call transcription tools to enable AI voice of customer, idea management, and win/loss analysis<li>Connect project management and roadmapping tools to enable bidirectional status tracking and sync.</li>Connect comms and CRM tools to push enablement information to teammates.</ul><br><strong>FAQs:</strong><br><ol><li>How difficult to configure are the integrations? Most integrations take less than 2 minutes to set up! All you need is a login.</li><li>Do I need any special permissions? In most cases, no. However, depending on your IT admin settings, you may need admin permissions.</li><li>How do you use my data? Is there any security documentation you can provide for my IT team? Ignition will never overwrite or mess up data in the tools you integrate. All your data is secure and private to your workspace. For more info, see this attached <a href="https://for-data-development.s3.amazonaws.com/aa58be7e-96dd-410b-89cf-5be5f994d98d/edb2b43c-51ca-4c62-9ee1-9d97922f29d7/security_ai%20one%20pager.pdf">document.</a></li></ol></p>`

export const ONBOARDING_LAST_LOGIN_USER_STORAGE_NAME = 'onboarding_user_last_login'
export const LAST_ONBOARD_TIMESTAMP_COOKIE_NAME = 'last_onboarding_timestamp'
export const ONBOARDING_USER_COOKIE_NAME = 'onboarding_user'
export const ONBOARDING_USER_COOKIE_MAX_AGE = 60 * 60 * 24 // 1 day
